import type { NodeBase } from '../../../entities/Node';
import { NODE_TYPE_ITEM } from '../../types/nodeTypes';
import type { CatalogConfigProps } from './DefaultCatalogConfig';
import DefaultCatalogConfig, {
  IMAGE_EDITABLE,
  IMAGE_VIEW,
} from './DefaultCatalogConfig';

export default class RoomsCatalogConfig extends DefaultCatalogConfig {
  constructor(props: CatalogConfigProps) {
    super(props);
    this.editable = props.isEditorForCurrentMarket;
    this.allowedSources = [props.productsCatalogId];

    this.category.autoCategorisable = false;
    this.category.rename = props.isEditorForCurrentMarket;
    this.category.delete = props.isEditorForCurrentMarket;
    this.category.comment = false;
    this.category.import = false;
    this.category.redirectIdRequired = false;

    if (props.isGlobalMarket && props.isGlobalEditor) {
      this.category.deleteCategoryLevels = [1, 2];
    } else if (props.isEditorForCurrentMarket) {
      this.category.deleteCategoryLevels = [2];
    }

    this.category.publish = props.isEditorForCurrentMarket;
    this.category.translation = props.isEditorForCurrentMarket;
    this.category.levelRestriction = true;
    this.category.levelEditable = [1];
    this.category.image = props.isEditorForCurrentMarket
      ? IMAGE_EDITABLE
      : IMAGE_VIEW;
    this.category.productImage = 'DISABLED';
    this.category.categoryImageLevelRestriction = props.isEditorForCurrentMarket
      ? [1]
      : [];
    this.category.publishMinDaysDelay = 0;
    this.category.redirectIdRequired = false;

    this.catalog.availableForMarkets =
      props.isGlobalMarket && props.isEditorForCurrentMarket;
    this.catalog.translation =
      !props.isGlobalMarket && props.isEditorForCurrentMarket;

    this.allowRanking = props.isEditorForCurrentMarket;
    this.allowRankingLevels = [1, 2];
    this.newCategory = props.isGlobalMarket && props.isEditorForCurrentMarket;
    this.allowCutCategory = false;
    this.allowCopyCategory = false;
    this.moveDisabled = false;
    this.allowHoverActions = props.isEditorForCurrentMarket;
    this.item.copy = false;
    this.item.remove = false;
    this.item.cut = false;
  }

  canCopyNode = (node: NodeBase) => {
    if (node.level > 2) return false;

    return true;
  };

  canPaste({ nextParent, node }: { nextParent: NodeBase; node: NodeBase }): boolean {
    if (!this.editable) return false;
    if (!this.allowedSources.includes(node?.catalogId)) return false;

    if (
      node?.type === NODE_TYPE_ITEM &&
      nextParent?.category &&
      nextParent?.category?.childItemCount > 0
    ) {
      return true;
    }

    return nextParent?.level === 1;
  }
}
